import {PartialsModule} from '../app/views/partials/partials.module';
import {MatGridListModule} from '@angular/material/grid-list/typings';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPublicComponent } from './app-public.component';
import { Test1Component } from './test1/test1.component';
import { AppPublicRoutingModule } from './app-public-routing.module';
import { SharedModule } from '@shared/shared.module';
import { ThemeModule } from '@app/views/theme/theme.module';


import { CoreModule } from '@app/core/core.module';
import { FormsModule } from '@angular/forms';
import { Test2Component } from './test2/test2.component';

import { GViewerComponent } from './maps/gmaps/gviewer.component';
import { DeliveryConfirmComponent } from './delivery-confirm/delivery-confirm.component';
import { MatButtonModule, MatCardModule, MatCheckboxModule, MatIconModule, MatProgressSpinnerModule, MatTableModule } from '@angular/material';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
	declarations: [AppPublicComponent, Test1Component, Test2Component, GViewerComponent, DeliveryConfirmComponent],
  imports: [
    CoreModule,
    AppPublicRoutingModule,
    ServiceProxyModule,
    CommonModule,
    SharedModule,
    ThemeModule,
    PartialsModule,
    FormsModule,


    MatButtonModule,
    MatCheckboxModule,
   
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgbAlertModule,
  ]
})
export class AppPublicModule { }
